import { Controller } from "@hotwired/stimulus"
import { useClickOutside, useHover } from "stimulus-use"
import get from "lodash.get"

// Connects to data-controller="dropdown"
export default class extends Controller {
  static targets = ["button", "menu", "activeMark"]

  static values = {
    group: String,
    hover: { type: Boolean, default: true },
  }

  connect() {
    if (this.hoverValue !== false) {
      useHover(this, { element: this.element })
    }

    useClickOutside(this)

    this.element[this.identifier] = this

    this.onFocusOut = this.focusOut.bind(this)
    this.onFocusIn = this.focusIn.bind(this)

    this.element.addEventListener("focusout", this.onFocusOut)
    this.element.addEventListener("focusin", this.onFocusIn)

    this.closeTimer = null

    this.isHovering = false
    this.isOpen = get(this.element, "dataset.open") === "true"
    this.toggleVisibility()
  }

  disconnect() {
    this.element.addEventListener("focusout", this.onFocusOut)
    this.element.addEventListener("focusin", this.onFocusIn)
  }

  toggleVisibility() {
    this.menuTarget.classList.toggle("block", this.isOpen)
    this.menuTarget.classList.toggle("hidden", !this.isOpen)

    if (this.hasActiveMarkTarget) {
      this.activeMarkTarget.classList.toggle("block", this.isOpen)
      this.activeMarkTarget.classList.toggle("hidden", !this.isOpen)
    }

    this.buttonTarget.setAttribute(
      "aria-expanded",
      this.isOpen ? "true" : "false"
    )
  }

  openMenu() {
    this.isOpen = true
    this.dispatch("open", { detail: { group: this.groupValue } })
    this.toggleVisibility()
  }

  closeMenu() {
    this.isOpen = false
    this.stopClose()
    this.toggleVisibility()
    this.buttonTarget.blur()
  }

  toggleMenu() {
    if (this.isHovering) {
      return
    }

    if (this.buttonTarget.getAttribute("aria-expanded") === "true") {
      this.closeMenu()
    } else {
      this.openMenu()
    }
  }

  delayedClose(timeout) {
    clearTimeout(this.closeTimer)
    this.closeTimer = setTimeout(() => {
      this.closeMenu()
    }, timeout)
  }

  stopClose() {
    clearTimeout(this.closeTimer)
  }

  mouseEnter() {
    this.isHovering = true
    this.stopClose()
    this.openMenu()
  }

  mouseLeave() {
    this.isHovering = false
    this.delayedClose(500)
  }

  focusIn() {
    this.stopClose()
  }

  focusOut() {
    this.delayedClose(100)
  }

  clickOutside() {
    this.closeMenu()
  }

  groupClose({ target, detail: { group } }) {
    if (this.element !== target && group === this.groupValue) {
      this.closeMenu()
    }
  }
}
